import dayjs from 'dayjs';

const formatText = 'YYYY-MM-DD';
const formatTextFull = 'YYYY-MM-DD HH:mm:ss';

// 日期格式化
export const formatDate = (date) => date ? dayjs(date).format(formatText) : date;

// 日期格式化(带时间)
export const formatDateFull = (date) => date ? dayjs(date).format(formatTextFull) : date;
